// 提供了最新的 ECMAScript 功能在旧版浏览器中的实现
import 'core-js/stable'; 
// 这是用来支持 async/await 语法的运行时环境
import 'regenerator-runtime/runtime';
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import 'video.js/dist/video-js.css'
// 1. 导入 store 的实例对象
import store from './store/store'
// 分页组件
import Pagination from "@/views/component/pagination.vue";
// import { Dialog} from 'element-ui';
import './utils/pcOrPhone'
import './assets/css/font.css'
import './assets/css/global.css'
import { download } from '@/utils/request'
// 核心样式（必须，包含 ql-align-* 等基础类）
import 'quill/dist/quill.core.css'

// 可选：snow 主题样式（编辑时常用）
import 'quill/dist/quill.snow.css'

// 可选：bubble 主题样式
import 'quill/dist/quill.bubble.css'
import 'amfe-flexible'
// import './utils/rem'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'video.js/dist/video-js.css'
import './assets/css/public.css';
import MetaInfo from 'vue-meta-info'
Vue.use(MetaInfo)
// Vue.use(Dialog)
Vue.component('Pagination', Pagination)
Vue.config.productionTip = false
Vue.prototype.download = download
Vue.use(ElementUI);
store.dispatch('m_user/GetInfo')
store.dispatch('m_user/GetBottomInfo')
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
